import React from "react";
import {Icon, Tooltip, Typography} from "antd";
import FlightRoute from "../../../components/flight-route";

export interface CurrentLegHelperProps {
    record: any
}

const CurrentLegHelper = React.forwardRef<any, CurrentLegHelperProps>(function CurrentLegHelper({ record }, ref) {
    if (record._linkedDispatchByContract){
        const dispatch = record._linkedDispatchByContract;
        if (Array.isArray(dispatch) && dispatch.length > 0) {
            const departure = dispatch[0].departingDoc?.name;
            const destination = dispatch[0].destinationDoc?.name;

            let warning = null;

            if (dispatch.length > 1){

                const title = <>
                    <h4>Multiple dispatch flights found on this contract. Showing the first one.</h4>
                    <div>
                        <Typography.Text type="warning">
                            Current leg, ATO, and ETA may not be accurate.
                        </Typography.Text>
                    </div>
                </>

                warning = <Tooltip title={title}>
                                <span style={{ marginLeft: 6 }}>
                                    <Typography.Text type="warning"><Icon type="warning" /></Typography.Text>
                                </span>
                </Tooltip>
            }

            return <>
                <FlightRoute path={[departure || 'Unknown', destination || 'Unknown']} disableColors ref={ref} />
                {warning}
            </>
        }
    }

    return null;
})

export default CurrentLegHelper;